import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import {
  BotOverviewResponse,
  HealthResponse,
  TransactionsResponse,
} from '../../screens/Overview/types';
import { api } from '../services/api';

export interface ClientOverviewApiResponse {
  botsOverview: BotOverviewResponse;
  transactions: TransactionsResponse;
  health: HealthResponse;
  activeCluster: string | null;
}

interface OverviewState {
  botsOverview: BotOverviewResponse | null;
  transactions: TransactionsResponse | null;
  health: HealthResponse | null; // @TODO, at some point we want to split this up to improve performance
  activeCluster: string | null;
  isLoading: boolean;
}

const initialState: OverviewState = {
  botsOverview: null,
  transactions: null,
  health: null,
  activeCluster: null,
  isLoading: true,
};

const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    setOverviewData: (
      state,
      action: PayloadAction<ClientOverviewApiResponse>,
    ) => {
      state.botsOverview = action.payload.botsOverview;
      state.transactions = action.payload.transactions;
      state.health = action.payload.health;
      state.activeCluster = Object.keys(
        action.payload.botsOverview.clusters,
      )[0];
      state.isLoading = false;
    },
    setActiveCluster: (state, action: PayloadAction<string>) => {
      state.activeCluster = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      api.endpoints.getClientOverview.matchFulfilled,
      (state, { payload }) => {
        state.botsOverview = payload.botsOverview;
        state.transactions = payload.transactions;
        state.health = payload.health;
        state.activeCluster = Object.keys(payload.botsOverview.clusters)[0];
        state.isLoading = false;
      },
    );
  },
});

export const { setOverviewData, setActiveCluster } = overviewSlice.actions;
export const selectClientOverview = (state: RootState) => state.overview;
export default overviewSlice.reducer;
